import api from '../api'; // your configured axios instance
import { API_URL } from '../config';

// Fetch all contracts
export async function getAllContracts() {
  try {
    const response = await api.get('/contracts');
    return response.data;
  } catch (error) {
    console.error("Error fetching contracts:", error);
    throw error;
  }
}


export async function deactivateEmployee(employeeId) {
    try {
        // This calls the controller method that fires the event
        const response = await api.patch(`/employees/${employeeId}/deactivate`);
        return response.data;
    } catch (error) {
        console.error("Error deactivating employee:", error);
        throw error;
    }
}

// Create a new contract
export async function createContract(employeeId, contractData, file) {
  const contractDTO = {
    type: contractData.contractType,
    startDate: contractData.startContract,
    endDate: contractData.endOfContract || null,
    status: contractData.status.toUpperCase(),
    employeeId: employeeId,
    salary: contractData.salary || 0.0,
    workHours: contractData.workHours || 0,
    file: null,
  };

  const formData = new FormData();
  formData.append('contract', new Blob([JSON.stringify(contractDTO)], { type: 'application/json' }));
  if (file) {
    formData.append('file', file);
  }

  try {
    const response = await api.post(`/contracts?employeeId=${employeeId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating contract:', error);
    throw error;
  }
}

// Update an existing contract
export async function updateContract(contractId, contractData, file) {
  const contractDTO = {
    type: contractData.contractType,
    startDate: contractData.startContract,
    endDate: contractData.endOfContract || null,
    status: contractData.status.toUpperCase(),
    employeeId: contractData.userId || contractData.employeeId,
    salary: contractData.salary || 0.0,
    workHours: contractData.workHours || 0,
    file: null,
  };

  const formData = new FormData();
  formData.append('contract', new Blob([JSON.stringify(contractDTO)], { type: 'application/json' }));
  if (file) {
    formData.append('file', file);
  }

  try {
    const response = await api.put(`/contracts/${contractId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating contract:', error);
    throw error;
  }
}

export async function deleteContract(contractId) {
  try {
    const response = await api.delete(`/contracts/${contractId}`);
    return response.status === 204;
  } catch (error) {
    console.error('Error deleting contract:', error);
    throw error;
  }
}

// Fetch contract detail by employee ID (active contract or latest contract)
export async function getContractByEmployeeId(employeeId) {
  try {
    const response = await api.get(`/contracts/employee/${employeeId}`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      console.log(`No contract found for employee ${employeeId}`);
      return null;
    }
    console.error(`Error fetching contract for employee ${employeeId}:`, error);
    throw error;
  }
}

// Fetch all contracts for an employee (history)
export async function getContractsByEmployeeId(employeeId) {
  try {
    const response = await api.get(`/contracts/employee/${employeeId}/all`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return [];
    }
    console.error(`Error fetching contracts for employee ${employeeId}:`, error);
    throw error;
  }
}

export async function getMyContract() {
  try {
    const response = await api.get('/contracts/my-contract');
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      console.log("No active contract found for user");
      return null;
    }
    console.error("Error fetching contract:", error);
    throw error;
  }
}